import { filterLocations } from "../../../../utils/filterMultiLevelFields";


export const useHandleOnSubmit = (queryParams, updateUrlParams) => {
  const handleOnSubmit = (module, params) => {

    if (Object.keys(queryParams.current).includes("includeMakeIds")) {
      // @ts-ignore
      delete queryParams.current.includeMakeIds;
    }

    if (Object.keys(queryParams.current).includes("includeModelIds")) {
      // @ts-ignore
      delete queryParams.current.includeModelIds;
    }

    if (
      Object.keys(params).includes("categoryLv2Ids") &&
      Object.keys(queryParams.current).includes("categoryLv1Ids")
    ) {
      // @ts-ignore
      delete queryParams.current.categoryLv1Ids;
    }

    if (
      Object.keys(params).includes("categoryLv1Ids") &&
      Object.keys(queryParams.current).includes("categoryLv2Ids")
    ) {
      // @ts-ignore
      delete queryParams.current.categoryLv2Ids;
    }

    const isSameCategory = queryParams.current.category === params.category;

    // @ts-ignore
    if (!isSameCategory) {
      // @ts-ignore
      const { text } = queryParams.current;
      queryParams.current = text
        ? { ...queryParams.current, text }
        : queryParams.current;
    }

    const rawSearchData = module
      ? {
        text: queryParams.current.text,
        category: queryParams.current.category,
        ...params,
        module,
        // @ts-ignore
        page: params.page ? params.page : undefined // reset page param if page is undefined in params
      }
      : {
        text: queryParams.current.text,
        category: queryParams.current.category,
        module: queryParams.current.module,
        ...params,
        // @ts-ignore
        page: params.page ? params.page : undefined // reset page param if page is undefined in params
      };

    queryParams.current = filterLocations(rawSearchData, params);

    //handleSearch();

    updateUrlParams(queryParams.current);
  };

  return handleOnSubmit
}


// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/hooks/useHandleOnSubmit.ts